import { Link } from "react-router-dom";
import { MartzmakesWordmarkLink } from "./MartzmakesWordmark";

/**
 * Site-wide footer — every page renders this for consistency. Carries the
 * domain string, alpha badge, legal links, and the martzmakes wordmark
 * (blinking-cursor link to martzmakes.com).
 */
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <code className="mono">nightswarm.app</code>
      <span className="sep">·</span>
      <span className="badge-alpha">Beta</span>
      <span className="sep">·</span>
      <Link to="/privacy">Privacy</Link>
      <span className="sep">·</span>
      <Link to="/terms">Terms</Link>
      <span className="built-by">
        <span>built by</span>
        <MartzmakesWordmarkLink size={12} />
      </span>
    </footer>
  );
}
